import { createLoaderImp } from '../../../../components/ozmoit/common';
import { getContinuousEducationSectionsFiltersFormAction } from '../actions';

const {
  useLoaderData: useContinuousEducationSectionsFiltersFormLoaderData,
  LoaderConsumerSimple,
  LoaderProvider,
} = createLoaderImp({
  action: getContinuousEducationSectionsFiltersFormAction,
});

function ContinuousEducationSectionsFiltersFormLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return (
    <LoaderProvider {...props}>
      <LoaderConsumerSimple>{children}</LoaderConsumerSimple>
    </LoaderProvider>
  );
}

export {
  ContinuousEducationSectionsFiltersFormLoader,
  useContinuousEducationSectionsFiltersFormLoaderData,
};
